import { call, put, takeEvery } from "redux-saga/effects"
import {
    ADD_INTERVIEWER,
    GEN_OFFER_LETTER,
    GET_EDIT_GEN_OFFER_LETTER_DETAILS,
    GET_GEN_OFFER_LETTER_DETAIL,
    GET_HIRE_CANDIDATE,
    GET_INTERVIEWERS,
    GET_INTERVIEW_ROUNDS,
    HIRENEURON_VIDEO_INTEGRATION,
    OFFER_LETTER_TYPE,
    POST_ABOUT_INTERVIEW,
    POST_INTERVIEW_DETAILS,
    RESCHEDULE_INTERVIEW,
    SAVE_HIRE_CANDIDATE_DATA
} from "./actionTypes"

import {
    VideoInterview,
    addInterviewerError,
    addInterviewerSuccess,
    genOfferLetterFailed, genOfferLetterSuccess,
    getGenOfferLetterDetailsFailed,
    getGenOfferLetterDetailsSuccess,
    getHireCandidateDetailsFailed, getHireCandidateDetailsSuccess,
    getInterviersDetailsFailed,
    getInterviewRoundsFailed,
    getInterviewRoundsSuccess,
    getInterviewerDetailsSuccess,
    offerLetterTypeListFailed, offerLetterTypeListSuccess,
    postInterviewDetailsError,
    postInterviewDetailsSuccess,
    rescheduleInterviewFailure,
    revokeOfferDetailsFail,
    revokeOfferDetailsSuccess,
    saveHireCandidateDataFailed, saveHireCandidateDataSuccess,
    tokenVerifyFail,
    tokenVerifySuccess
} from "./actions"

import * as constClass from "../../../../../common/constant/constantURL"
import { post } from "../../../../../helpers/api_helper"
import { addInterviewerPost, cancelOfferletter, getCall, getInterviewersInfo, getRequest, postAboutOnInterview, postScheduleInterview } from "../../../../../helpers/fakebackend_helper"

function* getInterviewersHandler({ payload: { jobId,allList} }){
    try{
        let url=constClass.REST_API_GET_INTERVIEWERS 
          //to show specific  interviewer list to  recruiter user 
        if(jobId !== undefined && jobId !== null && jobId !== ""){
        url = `${url}?jobId=${jobId}`
        }
        //to show all interviewer list to  recruiter user 
        if(allList !== undefined && allList !== null && allList !== ""){
            url = `${url}?allList=${allList}`
        }
        let responsJSON = yield call(getInterviewersInfo, url);
        yield put(getInterviewerDetailsSuccess(responsJSON))

    }
    catch(error){
        
        yield put(getInterviersDetailsFailed(error))

    }
}

function* postInterviewHandler(obj){
    try{
        const data=obj.payload
        const url=constClass.REST_API_POST_ABOUT_INTERVIEW;
         let responsJSON = yield call(postScheduleInterview, url,data);
        yield put(postInterviewDetailsSuccess(responsJSON))
    }
    catch(error){
        if(error.startsWith("https")){
            yield put(VideoInterview(error))
        }
        else {
            yield put(postInterviewDetailsError(error))
        }
       
    }

}

function* addInterviewerHandler(obj){
    try{
        const data=obj.payload
        let url="configuration/manager/interviewer"
        yield call(addInterviewerPost, url,data);
        yield put(addInterviewerSuccess("Interviewer has been added successfully."))
    }
    catch(error){
        yield put(addInterviewerError(error))

    }
}

function* handleRescheduleInterview(obj){
    try{
       
    }
    catch(error){
         yield put(rescheduleInterviewFailure(error))
    }
}

function* postAboutInterviewHandler(data){
    try{
        let url=constClass.REST_API_POST_ABOUT_INTERVIEW
        yield call(postAboutOnInterview,url,data.payload)
    }
    catch(error){
        // console.log(error)
    }

}
function* getInterviewersRoundsHandler({ payload: { jobId } }){
    try{
        const url=constClass.REST_API_GET_INTERVIEW_ROUNDS+`?jobId=${jobId}` 
        let responsJSON = yield call(getRequest, url);
        yield put(getInterviewRoundsSuccess(responsJSON))


    }
    catch(error){
     
        yield put(getInterviewRoundsFailed(error))

    }
}

function* getHireCandidateData({ payload: { jobId ,candidateId} }){
    try{
        const url=constClass.REST_API_GET_HIRE_CANDIDATE_DATA+`jobId=${jobId}&candidateId=${candidateId}` 
        let responsJSON = yield call(getRequest, url);
        yield put(getHireCandidateDetailsSuccess(responsJSON))


    }
    catch(error){
     
        yield put(getHireCandidateDetailsFailed(error))

    }
}
function* saveHireCandidateDataHandler({ payload: { data} }){
    try{
        
        const url=constClass.REST_API_GET_SAVE_HIRE_CANDIDATE_DATA 
        
        let responsJSON = yield call(post, url,data);
       
        yield put(saveHireCandidateDataSuccess(responsJSON))


    }
    catch(error){
     
        yield put(saveHireCandidateDataFailed(error))

    }
}



function* templateOfferLetter({ payload: { data} }){
    try{
        let url="";
        if(data !== undefined)
        {          
            url =constClass.REST_API_TEMPLATE_OFFER_LETTER+"?pageSize=50&page=0&jobId="+data
        }else{
            url=constClass.REST_API_TEMPLATE_OFFER_LETTER+"?pageSize=50&page=0"
        }      
        let responsJSON = yield call(getRequest, url);
        yield put(offerLetterTypeListSuccess(responsJSON))
    }
    catch(error){
     
        yield put(offerLetterTypeListFailed(error))

    }
}

function* generateOfferLetter({ payload: { data} }){
    try{
      
        const url=constClass.REST_API_GEN_OFFER_LETTER
        let responsJSON = yield call(post, url,data);
        yield put(genOfferLetterSuccess(responsJSON))
    }
    catch(error){
     
        yield put(genOfferLetterFailed(error))

    }
}

function* getOfferLetterDetails({ payload: { jobId,candidateId} }){
    try{
      
        const url=constClass.REST_API_GEN_OFFER_LETTER+`?jobId=${jobId}&candidateId=${candidateId}` 
        let responsJSON = yield call(getRequest, url);
        yield put(getGenOfferLetterDetailsSuccess(responsJSON))
    }
    catch(error){
     
        yield put(getGenOfferLetterDetailsFailed(error))

    }
}

function* meetingTokenVerify({ payload: {json} }){
    try{
        const url=constClass.REST_API_MEETING_TOKEN_VERIFY+`?userID=${json.userID}&userName=${json.userName}&roomID=${json.roomID}&expired_ts=10800`
        let responsJSON = yield call(getCall, url);
        yield put(tokenVerifySuccess(responsJSON))
        // console.log("saga", responsJSON)
    }
    catch(error){
        yield put(tokenVerifyFail(error))
    }
}


function* EditOfferLetterHandler({ payload: {json} }){
    try{
        const url=constClass.REST_API_FOR_EDIT_OFFER_LETTER
        let responsJSON = yield call(cancelOfferletter, url, {"id":json});
        yield put(revokeOfferDetailsSuccess(responsJSON))
    }
    catch(error){
        yield put(revokeOfferDetailsFail(error))
    }
}

function* scheduleInterviewSaga() {
    yield takeEvery (GET_INTERVIEWERS, getInterviewersHandler);
    yield takeEvery (POST_INTERVIEW_DETAILS,postInterviewHandler);
    yield takeEvery(ADD_INTERVIEWER,addInterviewerHandler)
    yield takeEvery(RESCHEDULE_INTERVIEW,handleRescheduleInterview)
    yield takeEvery(POST_ABOUT_INTERVIEW,postAboutInterviewHandler);
    yield takeEvery(GET_INTERVIEW_ROUNDS,getInterviewersRoundsHandler);
    yield takeEvery(GET_HIRE_CANDIDATE,getHireCandidateData);
    yield takeEvery(SAVE_HIRE_CANDIDATE_DATA,saveHireCandidateDataHandler);
    yield takeEvery(OFFER_LETTER_TYPE,templateOfferLetter);
    yield takeEvery(GEN_OFFER_LETTER,generateOfferLetter);
    yield takeEvery(GET_GEN_OFFER_LETTER_DETAIL,getOfferLetterDetails);
    yield takeEvery(HIRENEURON_VIDEO_INTEGRATION,meetingTokenVerify);
    yield takeEvery(GET_EDIT_GEN_OFFER_LETTER_DETAILS, EditOfferLetterHandler);
  }
  
  export default scheduleInterviewSaga